import { AdminGridTable } from "../../../components/admin-console/admin-grid-table";
import { DOCUMENT_KIT_COLUMNS, MOCK_CONSTRUCTOR_DOCUMENT_KITS } from "../constructor-documents-page.lib";
import { DocumentKitDetailPanel } from "./document-kit-detail-panel";

/**
 * Таблица комплектов документов конструктора (мок, бэкенда ещё нет).
 * Раскрытие строки (master/detail) показывает состав комплекта и виды работ.
 */
export const ConstructorDocumentsTable = () => (
  <AdminGridTable
    tableId="admin-documents-table"
    columns={DOCUMENT_KIT_COLUMNS}
    rows={MOCK_CONSTRUCTOR_DOCUMENT_KITS}
    masterDetail
    detailRowAutoHeight
    detailCellRenderer={DocumentKitDetailPanel}
    isRowMaster={(kit) => Boolean(kit.expanded)}
    className="h-[24rem]"
  />
);
